module.exports = __webpack_public_path__ + "static/media/21ECLAC45.92d1282e.jpg";